import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import VideoCard from "@/components/VideoCard";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [format, setFormat] = useState("all");
  const [sort, setSort] = useState("new");
  const [results, setResults] = useState([]);
  const hashtag = params.get("hashtag");

  useEffect(() => {
    const p = { q: params.get("q") || undefined, sort };
    if (format !== "all") p.format = format;
    if (hashtag) p.hashtag = hashtag;
    api.get("/videos", { params: p }).then(r=>setResults(r.data));
  }, [params, format, sort, hashtag]);

  const submit = (e) => { e.preventDefault(); setParams({ q }); };

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 pt-6">
      {hashtag && <div className="mb-3 text-sm"><span className="chip px-3 py-1 rounded-full text-[#08D9D6]">#{hashtag}</span></div>}
      <form onSubmit={submit} className="relative">
        <SearchIcon size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/50"/>
        <input value={q} onChange={e=>setQ(e.target.value)} data-testid="search-page-input"
               className="w-full h-12 rounded-full bg-white/5 border border-white/10 pl-11 pr-4 focus:outline-none focus:border-[#08D9D6]"
               placeholder="Search Jixxeo"/>
      </form>
      <div className="flex flex-wrap gap-2 mt-4">
        {["all","long","short"].map(f=>(
          <button key={f} onClick={()=>setFormat(f)} className={`chip jx-btn px-4 h-9 rounded-full text-sm font-semibold ${format===f?'chip-active':''}`}>
            {f==="all"?"All":f==="long"?"Long-form":"Loop"}
          </button>
        ))}
        <div className="ml-auto flex gap-2">
          {[["new","New"],["trending","Trending"],["liked","Most liked"]].map(([k,l])=>(
            <button key={k} onClick={()=>setSort(k)} className={`chip jx-btn px-4 h-9 rounded-full text-sm font-semibold ${sort===k?'chip-active':''}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-4 gap-y-8 mt-6">
        {results.map(v=><VideoCard key={v.id} v={v}/>)}
        {results.length===0 && <div className="text-white/50 text-sm">No results.</div>}
      </div>
    </div>
  );
}
